import { useAtomValue } from 'jotai';
import { popupOptionsAtom } from '../../../store/global/atoms';

export const usePopupValue = () => {
  const popupOptions = useAtomValue(popupOptionsAtom);

  return popupOptions;
};
